import React from "react";
import { HeartHandshake, Clock, Languages, ShieldCheck, Video, LayoutGrid } from "lucide-react";

const REASONS = [
  {
    icon: HeartHandshake,
    title: "Atención personalizada",
    desc: "Cada cliente recibe un servicio único, adaptado a su situación y objetivos.",
  },
  {
    icon: Clock,
    title: "+10 años de experiencia",
    desc: "Más de una década ayudando a la comunidad hispana en Florida y Estados Unidos.",
  },
  {
    icon: Languages,
    title: "Servicio bilingüe",
    desc: "Te atendemos con la misma calidad en español o inglés según lo prefieras.",
  },
  {
    icon: ShieldCheck,
    title: "Honestidad y transparencia",
    desc: "Presupuestos claros, sin sorpresas. Te explicamos cada paso del proceso.",
  },
  {
    icon: Video,
    title: "Presencial y virtual",
    desc: "Atención en oficina o desde donde estés, con firma remota certificada (RON).",
  },
  {
    icon: LayoutGrid,
    title: "Todo en un solo lugar",
    desc: "Impuestos, ITIN, LLC, notaría, migración y seguros. Una sola casa de confianza.",
  },
];

export default function WhyChoose() {
  return (
    <section id="por-que-elegirnos" className="py-24 lg:py-32 bg-white" data-testid="why-choose-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl reveal">
          <div className="text-xs font-semibold text-[#0B2D5C] tracking-[0.2em] uppercase mb-4">
            Por qué elegirnos
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0f172a] leading-[1.1]">
            ¿Por qué elegir{" "}
            <span className="text-[#0B2D5C]">Great Solutions US</span>?
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {REASONS.map((r, i) => (
            <div
              key={r.title}
              className="reveal p-7 border border-[#e2e8f0] rounded-sm hover:border-[#C89B2C] hover:shadow-lg transition-all duration-300 bg-[#f8fafc] hover:bg-white"
              style={{ transitionDelay: `${i * 40}ms` }}
              data-testid={`why-card-${i}`}
            >
              <div className="w-12 h-12 rounded-sm bg-[#0B2D5C] flex items-center justify-center mb-5">
                <r.icon className="text-white" size={22} strokeWidth={1.75} />
              </div>
              <h3 className="font-display font-semibold text-lg text-[#0f172a] mb-2">{r.title}</h3>
              <p className="text-[15px] text-[#475569] leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
